/* eslint-disable react/no-danger */
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { remark } from "remark";
import html from "remark-html";
import styles from "./index.module.scss";

const Markdown = ({ children, className = "", style = {} }) => {
  const rendered = useMemo(
    () =>
      remark()
        .use(html)
        .processSync(children || "")
        .toString(),
    [children]
  );
  return (
    <div
      style={style}
      className={[styles.markdown, className].filter(Boolean).join(" ")}
      dangerouslySetInnerHTML={{ __html: rendered }}
    />
  );
};

Markdown.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  )
};

Markdown.defaultProps = {
  className: "",
  style: {}
};

export default Markdown;
